import { MedicationKnowledge } from '@teschglobal/tg-fhir-react-components/dist/types'
import React, { FC } from 'react'
import { Spinner } from 'react-bootstrap'
import DrugSummary from '../DrugSummary'

interface DrugResultsProps {
    data?: MedicationKnowledge[]
    total?: number
    isLoading: boolean
    selectedLetter: string
}

const DrugResults: FC<DrugResultsProps> = ({
    data,
    total,
    isLoading,
    selectedLetter
}) => {
    if (isLoading) {
        return (
            <div className="mt-4">
                <Spinner animation="border" />
            </div>
        )
    }

    if (!data || total === 0) {
        return (
            <div className="mt-4">
                No drugs found for this letter.
            </div>
        )
    }

    return (
        <div className="mt-4">
            {selectedLetter && (
                <h4>
                    {selectedLetter}
                </h4>
            )}
            {data.map((drug: MedicationKnowledge, index: number) => (
                <details
                    key={`${drug.id}-${index}`}
                    className="drug-item mb-3"
                >
                    <summary className="fw-semibold">
                        {drug?.code?.text}
                    </summary> 

                <DrugSummary drug={drug}/>

                </details>
            ))}
        </div>
    )
}
export default DrugResults
